module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Candidate`s details"}}')
  delete Component.options._Ctor
}
